export default "__VITE_ASSET__DJ$_hLMy__"